import { useAuth } from "@mindlercare/auth-ui";
import { useUnleashContext, FlagProvider } from "@unleash/proxy-client-react";
import { PropsWithChildren, useEffect } from "react";

export type UnleashConfig = {
  url: string;
  clientKey: string;
  appName: string;
  environment: string;
};

const UnleashProvider = ({
  children,
  config,
}: PropsWithChildren<{ config: UnleashConfig }>) => {
  return <FlagProvider config={config}>{children}</FlagProvider>;
};

const useInitUnleash = () => {
  const { userId, market } = useAuth();
  const updateContext = useUnleashContext();
  useEffect(() => {
    updateContext({
      userId: `${userId}`,
      properties: {
        marketISO2: market,
      },
    });
  }, [userId, market, updateContext]);
};

export { UnleashProvider, useInitUnleash };
